import type { ResourceResponse } from "types";
import { useFileUpload } from "hooks";
import { ApiRoutes } from "consts/enpoints/api";
import { ECommerceOnboardingFilableResource } from "consts/ecommerce";
import { Merchant as MerchantType } from "features/ecommerce/types";
import { Merchant } from "ui/forms/ECommerce";

export const useIdentityFileUpload = () => {
    const uploadFile = useFileUpload();

    const handleIdentityFileUpload = (uboIdentity: Merchant.UBOIdentityVerification.Identity) =>
        async ({ data }: ResourceResponse<MerchantType.UboIdentity>) => {
            const requests = Array.from<ReturnType<typeof uploadFile>>([]);

            for (const field of [
                Merchant.UBOIdentityVerification.FormField.IdentityFileKey,
                Merchant.UBOIdentityVerification.FormField.AddressFileKey
            ]) {
                const file = uboIdentity[field];

                if (!file || !(file instanceof File)) {
                    continue;
                }

                requests.push(
                    uploadFile({
                        url: ApiRoutes.PostOnboardingsFiles(),
                        files: [
                            {
                                field,
                                file,
                                resource: ECommerceOnboardingFilableResource.UboIdentities,
                                identifier: data.pki
                            }
                        ]
                    })
                );
            }

            return Promise.allSettled(requests);
        };

    return {
        handleIdentityFileUpload
    };
};

export default useIdentityFileUpload;
